// ponytail: client-side merge of three existing endpoints — no unified
// activity endpoint exists. Each source maps to one typed row; sort by date desc.
function ts(row) { return new Date(row.created_at || row.date || 0).getTime() || 0; }

function orderHref(teamId, orderId) {
  return teamId && orderId ? `/teams/${teamId}/orders/${orderId}` : undefined;
}

export function mapNoteForFeed(note = {}) {
  return { ...note, created_at: note.created_at || note.human_created_at };
}

function buildFileRows(attachments) {
  const groups = new Map();
  attachments.forEach((a) => {
    const key = `${a.human_created_at || ''}|${a.uploaded_by || ''}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(a);
  });
  return Array.from(groups.entries()).map(([key, files]) => {
    const first = files[0];
    const n = files.length;
    return {
      id: `files-${key}`,
      type: 'files',
      title: `${n} file${n === 1 ? '' : 's'} added`,
      meta: [first.human_created_at, first.uploaded_by ? `by ${first.uploaded_by}` : null].filter(Boolean).join(' · '),
      body: 'Saved to files',
      files,
      date: ts({ created_at: first.human_created_at }),
    };
  });
}

export function buildActivityFeed({ notes = [], transactions = [], donations = [], attachments = [], teamId } = {}) {
  const rows = [
    ...notes.map((n) => ({ id: `note-${n.id}`, type: 'note', title: 'Note', meta: n.created_at, body: n.body, date: ts(n), note: n })),
    ...buildFileRows(attachments),
    ...donations.map((d) => ({ id: `gift-${d.id}`, type: 'giving', title: 'Gift received', meta: d.created_at, body: `${d.amount}${d.description ? ` · ${d.description}` : ''}`, date: ts(d), href: orderHref(teamId, d.id) })),
    ...transactions.map((t) => ({ id: `order-${t.id}`, type: 'order', title: 'Order placed', meta: t.date, body: `${t.tickets_sold} tickets · ${t.title} · ${t.ticket_price}`, date: ts(t), href: orderHref(teamId, t.orderId) })),
  ];
  return rows.sort((a, b) => b.date - a.date);
}

export function feedCounts(items) {
  return {
    all: items.length,
    notes: items.filter((i) => i.type === 'note').length,
    tickets: items.filter((i) => i.type === 'order').length,
    giving: items.filter((i) => i.type === 'giving').length,
  };
}
